import React from "react";
import * as S from "./styles";

const Error401 = ({ message, ...props }) => {

  return (
    <S.Wrapper>
      <S.Title>Ops!</S.Title>
      <S.ErrorDescription>
       {message || "Ocorreu um erro inesperado (Erro 401)"}
      </S.ErrorDescription>
    </S.Wrapper>
  );
};

export default Error401;
